import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#6B4F3B" }, // 짙은 브라운
    background: {
      default: "#f6f3ee",  // 따뜻한 베이지
      paper: "#ffffff",    // 카드, 모달
      banner: "#ede8df",   // 배너 밝은 베이지
      appbar: "#e0d8ce",   // 앱바
    },
    text: {
      primary: "#333333",
      secondary: "#777777",
      white: "#ffffff",
    }
  },
  typography: {
    fontFamily: "'Noto Sans KR', sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",   // 버튼 대문자 방지
          fontWeight: 600,
          borderRadius: "20px",
          boxShadow: "none",
        },
        containedPrimary: {
          backgroundColor: "#6B4F3B",
          "&:hover": {
            backgroundColor: "#5a3f2f",
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: "16px",
          backgroundColor: "#ffffff",
          padding: "24px",
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          borderRadius: "50%",
          fontWeight: 600,
          color: "#555",
          "&.Mui-selected": {
            backgroundColor: "#6B4F3B",
            color: "#fff",
          },
        },
      },
    },
  },
});

export default theme;
